/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddServiceDefinition200Response,
  AddStation200Response,
  AddUser200Response,
  GetGroups200Response,
  GetStations200Response,
  GetUsers200Response,
  GroupDefinition,
  ServiceDefinition,
  Station,
  User,
  UserDefinition,
  UserGroupUid,
  UserMmsiGet200Response,
} from '../models';
import {
    AddServiceDefinition200ResponseFromJSON,
    AddServiceDefinition200ResponseToJSON,
    AddStation200ResponseFromJSON,
    AddStation200ResponseToJSON,
    AddUser200ResponseFromJSON,
    AddUser200ResponseToJSON,
    GetGroups200ResponseFromJSON,
    GetGroups200ResponseToJSON,
    GetStations200ResponseFromJSON,
    GetStations200ResponseToJSON,
    GetUsers200ResponseFromJSON,
    GetUsers200ResponseToJSON,
    GroupDefinitionFromJSON,
    GroupDefinitionToJSON,
    ServiceDefinitionFromJSON,
    ServiceDefinitionToJSON,
    StationFromJSON,
    StationToJSON,
    UserFromJSON,
    UserToJSON,
    UserDefinitionFromJSON,
    UserDefinitionToJSON,
    UserGroupUidFromJSON,
    UserGroupUidToJSON,
    UserMmsiGet200ResponseFromJSON,
    UserMmsiGet200ResponseToJSON,
} from '../models';

export interface AddGroupRequest {
    json: GroupDefinition;
}

export interface AddServiceDefinitionRequest {
    serviceDefinition: ServiceDefinition;
}

export interface AddStationRequest {
    station: Station;
}

export interface AddUserRequest {
    user: User;
}

export interface DelServiceDefinitionRequest {
    uuid: string;
}

export interface DelStationRequest {
    uuid: string;
}

export interface GroupUidDeleteRequest {
    uid: string;
}

export interface GroupUidGetRequest {
    uid: string;
}

export interface GroupUidPutRequest {
    uid: string;
    json: GroupDefinition;
}

export interface UpdateServiceDefinitionRequest {
    uuid: string;
    serviceDefinition: ServiceDefinition;
}

export interface UpdateStationRequest {
    uuid: string;
    station: Station;
}

export interface UserMmsiGetRequest {
    dc: number;
    query?: string;
}

export interface UserUidDeleteRequest {
    uid: string;
}

export interface UserUidGetRequest {
    uid: string;
}

export interface UserUidPutRequest {
    uid: string;
    json: UserDefinition;
}

/**
 * 
 */
export class ConfigurationApi extends runtime.BaseAPI {

    /**
     * Create a new group
     * Create a group
     */
    async addGroupRaw(requestParameters: AddGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroupUid>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling addGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GroupDefinitionToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupUidFromJSON(jsonValue));
    }

    /**
     * Create a new group
     * Create a group
     */
    async addGroup(requestParameters: AddGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroupUid> {
        const response = await this.addGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create service definition
     * Create service definition
     */
    async addServiceDefinitionRaw(requestParameters: AddServiceDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddServiceDefinition200Response>> {
        if (requestParameters.serviceDefinition === null || requestParameters.serviceDefinition === undefined) {
            throw new runtime.RequiredError('serviceDefinition','Required parameter requestParameters.serviceDefinition was null or undefined when calling addServiceDefinition.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/servicedefinition`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceDefinitionToJSON(requestParameters.serviceDefinition),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddServiceDefinition200ResponseFromJSON(jsonValue));
    }

    /**
     * Create service definition
     * Create service definition
     */
    async addServiceDefinition(requestParameters: AddServiceDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddServiceDefinition200Response> {
        const response = await this.addServiceDefinitionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new station with specific parameters
     * Create a new station
     */
    async addStationRaw(requestParameters: AddStationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddStation200Response>> {
        if (requestParameters.station === null || requestParameters.station === undefined) {
            throw new runtime.RequiredError('station','Required parameter requestParameters.station was null or undefined when calling addStation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/station`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationToJSON(requestParameters.station),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddStation200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new station with specific parameters
     * Create a new station
     */
    async addStation(requestParameters: AddStationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddStation200Response> {
        const response = await this.addStationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new user
     * Create a user
     */
    async addUserRaw(requestParameters: AddUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddUser200Response>> {
        if (requestParameters.user === null || requestParameters.user === undefined) {
            throw new runtime.RequiredError('user','Required parameter requestParameters.user was null or undefined when calling addUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserToJSON(requestParameters.user),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddUser200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new user
     * Create a user
     */
    async addUser(requestParameters: AddUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddUser200Response> {
        const response = await this.addUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a service definition
     * Delete a service definition
     */
    async delServiceDefinitionRaw(requestParameters: DelServiceDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling delServiceDefinition.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/servicedefinition/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a service definition
     * Delete a service definition
     */
    async delServiceDefinition(requestParameters: DelServiceDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.delServiceDefinitionRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a station
     * Delete a station
     */
    async delStationRaw(requestParameters: DelStationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling delStation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/station/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a station
     * Delete a station
     */
    async delStation(requestParameters: DelStationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.delStationRaw(requestParameters, initOverrides);
    }

    /**
     * Return the configurations of all groups
     * Return all groups
     */
    async getGroupsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGroups200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGroups200ResponseFromJSON(jsonValue));
    }

    /**
     * Return the configurations of all groups
     * Return all groups
     */
    async getGroups(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGroups200Response> {
        const response = await this.getGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return configuration of all service definitions
     * Get all service definitions
     */
    async getServiceDefinitionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceDefinition>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/servicedefinition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceDefinitionFromJSON(jsonValue));
    }

    /**
     * Return configuration of all service definitions
     * Get all service definitions
     */
    async getServiceDefinitions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceDefinition> {
        const response = await this.getServiceDefinitionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return configuration of all stations
     * Return configuration of all stations
     */
    async getStationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStations200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/station`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStations200ResponseFromJSON(jsonValue));
    }

    /**
     * Return configuration of all stations
     * Return configuration of all stations
     */
    async getStations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStations200Response> {
        const response = await this.getStationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return the configurations of all users
     * Return all users
     */
    async getUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUsers200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Return the configurations of all users
     * Return all users
     */
    async getUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUsers200Response> {
        const response = await this.getUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a group
     * Delete a group
     */
    async groupUidDeleteRaw(requestParameters: GroupUidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling groupUidDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/group/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a group
     * Delete a group
     */
    async groupUidDelete(requestParameters: GroupUidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.groupUidDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Return the configuration of the specified group
     * Return group configuration
     */
    async groupUidGetRaw(requestParameters: GroupUidGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupDefinition>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling groupUidGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/group/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupDefinitionFromJSON(jsonValue));
    }

    /**
     * Return the configuration of the specified group
     * Return group configuration
     */
    async groupUidGet(requestParameters: GroupUidGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupDefinition> {
        const response = await this.groupUidGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update selected fields of a group
     * Update a group
     */
    async groupUidPutRaw(requestParameters: GroupUidPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling groupUidPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling groupUidPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/group/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GroupDefinitionToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update selected fields of a group
     * Update a group
     */
    async groupUidPut(requestParameters: GroupUidPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.groupUidPutRaw(requestParameters, initOverrides);
    }

    /**
     * Update a service definition
     * Update a service definition
     */
    async updateServiceDefinitionRaw(requestParameters: UpdateServiceDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling updateServiceDefinition.');
        }

        if (requestParameters.serviceDefinition === null || requestParameters.serviceDefinition === undefined) {
            throw new runtime.RequiredError('serviceDefinition','Required parameter requestParameters.serviceDefinition was null or undefined when calling updateServiceDefinition.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/servicedefinition/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceDefinitionToJSON(requestParameters.serviceDefinition),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a service definition
     * Update a service definition
     */
    async updateServiceDefinition(requestParameters: UpdateServiceDefinitionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateServiceDefinitionRaw(requestParameters, initOverrides);
    }

    /**
     * Update an existing station\'s configuration
     * Update a station
     */
    async updateStationRaw(requestParameters: UpdateStationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uuid === null || requestParameters.uuid === undefined) {
            throw new runtime.RequiredError('uuid','Required parameter requestParameters.uuid was null or undefined when calling updateStation.');
        }

        if (requestParameters.station === null || requestParameters.station === undefined) {
            throw new runtime.RequiredError('station','Required parameter requestParameters.station was null or undefined when calling updateStation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/system/station/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters.uuid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StationToJSON(requestParameters.station),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an existing station\'s configuration
     * Update a station
     */
    async updateStation(requestParameters: UpdateStationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStationRaw(requestParameters, initOverrides);
    }

    /**
     * Get User MMSI
     */
    async userMmsiGetRaw(requestParameters: UserMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserMmsiGet200Response>> {
        if (requestParameters.dc === null || requestParameters.dc === undefined) {
            throw new runtime.RequiredError('dc','Required parameter requestParameters.dc was null or undefined when calling userMmsiGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/user/mmsi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserMmsiGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get User MMSI
     */
    async userMmsiGet(requestParameters: UserMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserMmsiGet200Response> {
        const response = await this.userMmsiGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an existing user
     */
    async userUidDeleteRaw(requestParameters: UserUidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling userUidDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/user/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing user
     */
    async userUidDelete(requestParameters: UserUidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userUidDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Return the configuration of the specified user
     * Return user configuration
     */
    async userUidGetRaw(requestParameters: UserUidGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDefinition>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling userUidGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/user/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDefinitionFromJSON(jsonValue));
    }

    /**
     * Return the configuration of the specified user
     * Return user configuration
     */
    async userUidGet(requestParameters: UserUidGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDefinition> {
        const response = await this.userUidGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update selected fields of a user
     * Update an existing user
     */
    async userUidPutRaw(requestParameters: UserUidPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling userUidPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling userUidPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/user/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserDefinitionToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update selected fields of a user
     * Update an existing user
     */
    async userUidPut(requestParameters: UserUidPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userUidPutRaw(requestParameters, initOverrides);
    }

}
